import Cookies from 'js-cookie';
import { find } from 'lodash';

import { SIGNUP_INDUSTRIES } from 'components/forms/constants';
import API from 'utils/api';
import {
  gaSignupSuccess,
  gaTrackSignupError,
} from 'utils/google-analytics/gaTracking';
import { params as parseParams } from 'utils/mercury/partials/params';
import trackMercuryEvent from 'utils/mercury/trackMercuryEvent';

declare global {
  interface Window {
    __adroll: any;
    posthog: any;
  }
}

const handleSignupSubmit = (values, props) => {
  values.timezone_id = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  window.posthog?.capture('Sign up form submitted', {
    'Signed up with SSO': false,
    'SSO Type': 'None',
    'CTA variation': props.ctaVariation,
    'CTA # of steps': props.showInitFields ? 2 : 1,
    'Phone Number' : !!values?.phone,
  });

  const vihnsHotAdRollCode = () => {
    if (typeof window.__adroll === 'object') {
      // eslint-disable-next-line no-undef
      try {

        window.__adroll.record_user({ adroll_segments: '45e57456' });
        console.log('Adroll record created');
      } catch (err) {
        console.log('ERROR: adroll record_user error', err);
      }
    }
  };

  vihnsHotAdRollCode();

  
  API.signup(values).then(result => {
    const results = result.data;
    console.log({ results });
    if (props.onSuccessfulSignup) {
      props.onSuccessfulSignup(results);
    }

    Cookies.set('W-AccountId', results.user.account_id);
    Cookies.set('W-PersonId', results.user.login_id);
    Cookies.set('W-UserId', results.user.id);

    if (results?.user) {

      const trackData = {
        'account_ID': results?.user?.account_id,
        'person_ID': results?.user?.login_id,
        'user_ID': results?.user?.id,
        'company name': values?.company,
        'industry': find(SIGNUP_INDUSTRIES, { id: Number(values?.industry_id) })?.label,
        'number of employees': values?.ref_employees,
      };

      trackData['Signed up with SSO'] = false;
      trackData['SSO Type'] = 'None';
      trackData['CTA variation'] = props.ctaVariation;
      trackData['CTA # of steps'] = props.showInitFields ? 2 : 1;

      window.posthog?.capture('Sign up completed', trackData);
    }

    function sanitize(values) {
      delete values['firstName'];
      delete values['lastName'];
      delete values['fullName'];
      delete values['email'];
      delete values['phone'];
      JSON.stringify(values);
      return values;
    }

    // Mercury Tracking
    const params = () => parseParams();
    const attributes = {
      action: 'signupFormSuccess',
      annotations: sanitize(values),
      category: 'signupForm',
      label: null,
      origin: 'marketing',
      value: null,
      queryParams: params(),
    };

    trackMercuryEvent('marketing::marketingSiteEvent', attributes);

    // ga successful submission tracking
    const { id, ref_employees } = results.account;
    gaSignupSuccess(id, ref_employees);

    window.location.href = `${process.env.GATSBY_WIW_APP_URL}/login/setup/${results.set_password}?signup=true&email=${results?.user?.email}`;
  })
    .catch(error => {
      console.log(error);
      let catchResponse = error.response.data.code;
      if (catchResponse === 'REGISTRATION_LIMIT_EXCEEDED') {
        catchResponse = 9001;
      }
      props.updateResponse(catchResponse);
      props.updateFormValues(values);
      gaTrackSignupError(error);
    });

  {
    if (props.isZapier) {
      API.zapier(values);
    }
  }
};

export default handleSignupSubmit;